import $_ajax from "./ajax";
import $_date from "./date";
import $_localstorage from "./localstorage";
import $_crypto from "./crypto";
import $_utils from "./utils";
import $_urls from "./urls";
const utils = {
  $_ajax,
  $_date,
  $_localstorage,
  $_crypto,
  $_utils,
  $_urls
};

const UtilsInstall = function (Vue) {
  Vue.prototype.$_ajax = $_ajax;
  Vue.prototype.$_date = $_date;
  Vue.prototype.$_localstorage = $_localstorage;
  Vue.prototype.$_crypto = $_crypto;
  Vue.prototype.$_utils = $_utils;
  Vue.prototype.$_urls = $_urls;
};

export default UtilsInstall;
export { $_ajax, $_date, $_localstorage, $_crypto, $_utils, $_urls };